import Vue from 'vue';
import Toasted from 'vue-toasted';

Vue.use(Toasted, {
  duration: 2500,
  fitToScreen: true,
  singleton: true,
  type: 'success',
  position: 'bottom-center',
});



// WEBPACK FOOTER //
// ./src/addons/toasted.js